// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"55c4aa6c","181":"02857343","233":"b7e29b0d","253":"71fdf518","320":"cf0a38f6","341":"f752a1db","364":"a9ac53c7","411":"7ba74cfb","480":"995a927b","481":"83b00da4","554":"37488c11","596":"cda6018d","779":"d99b59cd","922":"b21a9d0b","970":"0f1eb33f"}[chunkId] + ".chunk.js";
};